import React, { Component } from 'react';
import { Button, Popover, PopoverHeader, PopoverBody } from 'reactstrap';

export default class WithdrawnReasonPopover extends Component {
    constructor(props) {
        super(props);
        this.state = {
            popoverOpen: false
        };
    }

    toggle = () => {
        this.setState({
            popoverOpen: !this.state.popoverOpen
        });
    }

    render() {
        return (
            <span>
                <Button size="sm" color="link" onClick={this.toggle} id="Popover2">
                    <i style={{ fontSize: 14 + 'px' }} className="icon-info"></i>
                </Button>
               {/*  <Button id="Popover1" type="button">
                    Launch Popover
                </Button> */}
                <Popover placement="bottom" isOpen={this.state.popoverOpen} target="Popover2" toggle={this.toggle}>
                    <PopoverHeader>Reason</PopoverHeader>
                    <PopoverBody>{this.props.withdrawnReason}</PopoverBody>
                </Popover>
            </span>
        );
    }
}